"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var node_1 = __importDefault(require("../../node"));
var react_redux_1 = require("react-redux");
var workflow_1 = require("../../../../../../../../reducers/slices/workflow/workflow");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var main_1 = require("../../../../../../../../reducers/slices/main");
var http_auth_modal_1 = __importDefault(require("../../http_auth_modal"));
var react_2 = require("@nextui-org/react");
var endpoint_data_mapper_1 = __importDefault(require("../../../../endpoint_data_mapper"));
var WebhookNode = function (props) {
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setNodeData = function (data) {
        dispatch((0, workflow_1.setNode)(__assign(__assign({}, props), { data: data })));
    };
    var requestTypeOptions = [
        { label: "GET", value: "GET" },
        { label: "POST", value: "POST" },
        { label: "PUT", value: "PUT" },
        { label: "DELETE", value: "DELETE" },
    ];
    var configurationComponent = function () {
        var _a, _b, _c, _d, _e, _f;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-2" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Input, { className: "nodrag", label: "URL: *", labelPlacement: "outside", placeholder: "e.g. https://api/example", type: "url", value: (_a = data.config.url) !== null && _a !== void 0 ? _a : "", onChange: function (e) { return setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { url: e.target.value }) })); }, isInvalid: !!((_b = data.errors) === null || _b === void 0 ? void 0 : _b.url), errorMessage: (_c = data.errors) === null || _c === void 0 ? void 0 : _c.url }), (0, jsx_runtime_1.jsx)("label", { children: "Request Type: *" }), (0, jsx_runtime_1.jsx)(react_2.Select, __assign({ selectedKeys: [(_d = data === null || data === void 0 ? void 0 : data.config) === null || _d === void 0 ? void 0 : _d.requestType], onChange: function (e) {
                        var selectedKey = e.target.value;
                        setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { requestType: selectedKey }) }));
                    }, isInvalid: !!((_e = data.errors) === null || _e === void 0 ? void 0 : _e.requestType), errorMessage: (_f = data.errors) === null || _f === void 0 ? void 0 : _f.requestType }, { children: requestTypeOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) })), (0, jsx_runtime_1.jsx)("label", { children: "Auth Type: *" }), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "secondary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            dispatch((0, main_1.setContentModal)({
                                title: "Set up your AUTH",
                                content: (0, jsx_runtime_1.jsx)(http_auth_modal_1.default, { value: (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.auth, onChange: function (auth) { return setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { auth: auth }) })); } }),
                            }));
                            return [2 /*return*/];
                        });
                    }); } }, { children: "AUTH" })), (0, jsx_runtime_1.jsx)("label", { children: "Schema Builder:" }), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "secondary", onClick: function () {
                        var _a;
                        dispatch((0, main_1.setContentModal)({
                            title: "Map your fields",
                            content: ((0, jsx_runtime_1.jsx)(endpoint_data_mapper_1.default, { value: (_a = data.config.fields) !== null && _a !== void 0 ? _a : [], onChange: function (fields) {
                                    setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { fields: fields }) }));
                                } })),
                        }));
                    } }, { children: "FIELDS" }))] })));
    };
    return ((0, jsx_runtime_1.jsx)(node_1.default, __assign({ category: "integration", configurationComponent: configurationComponent, icon: pro_light_svg_icons_1.faWebhook, data: data }, props)));
};
exports.default = (0, react_1.memo)(WebhookNode);
